module.exports = __webpack_public_path__ + "img/Contractor.79b5b019.svg";